import type React from 'react'
import { createContext, useContext } from 'react'
import { isNil } from 'utils'

import { useMapState } from '../map-state-store'
import type { InteractiveMap } from '../openlayers/InteractiveMap'

export const MapProvider: React.FC<MapProviderProps> = ({ children, map }) => {
  const isComparison = map.isComparison()
  const context = useMapState(isComparison)

  if (context === null) {
    throw new Error(
      `MapProvider: No map state found for ${isComparison ? 'comparison' : 'main'} map`
    )
  }
  return <MapContext value={{ map }}>{children}</MapContext>
}

export const useMapContext = () => {
  const context = useContext(MapContext)
  if (isNil(context)) {
    throw new Error('useMapContext must be used within a MapProvider')
  }
  return context
}

interface MapProviderProps extends MapContext {
  children: React.ReactNode
}

type MapContext = {
  map: InteractiveMap
}

const MapContext = createContext<MapContext | null>(null)
